import { SignIn } from './SignIn';

export const LoginPage = () => {
  return (
    <SignIn />
  );
};
